import { useEffect, useRef, useState } from "react";

/**
 * Custom hook to use state with callback
 * @param {T extends any} initial state
 * @param {(state: T) => void} callback to be called when state changes
 * @returns {[T, (state: T) => void]} [state, setState]
 */
function useCallbackState(initial, callback = () => {}) {
	const [state, setState] = useState(initial);
	const mount = useRef(false);
	const callbackRef = useRef(callback);

	// prevent infinite loop if callback changes on each render
	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		if (mount.current) {
			callbackRef.current(state);
		} else {
			mount.current = true;
		}
	}, [state]);

	return [state, setState];
}

export { useCallbackState };
